import type React from 'react'

import { Icon } from 'components'
import { theme } from 'styles/theme/hav-theme'

import * as S from './styles'

export type FilterTagProps = {
  content: string
  disabled?: boolean
  onRemove?: React.MouseEventHandler<HTMLButtonElement>
}

export const FilterTag: React.FC<FilterTagProps> = ({ content, disabled = false, onRemove }) => {
  return (
    <S.TagContainer disabled={disabled}>
      <S.TagText>{content}</S.TagText>
      {onRemove && (
        <S.RemoveButton onClick={onRemove} type="button">
          <Icon color={theme.colors.neutral[700]} icon="close" size="15" />
        </S.RemoveButton>
      )}
    </S.TagContainer>
  )
}
